import { render, staticRenderFns } from "./MapLoader.vue?vue&type=template&id=4f8e7dba&scoped=true"
import script from "./MapLoader.vue?vue&type=script&lang=ts"
export * from "./MapLoader.vue?vue&type=script&lang=ts"
import style0 from "./MapLoader.vue?vue&type=style&index=0&id=4f8e7dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e7dba",
  null
  
)

export default component.exports